import { z } from 'zod';

import { uuidSchema } from '../general';

export const entityTypeSchema = z.enum(['fund', 'org']);
export const entityTypeWithSubprojectSchema = z.enum([...entityTypeSchema.options, 'subproject']);
export type EntityType = z.infer<typeof entityTypeSchema>;
export type EntityTypeWithSubproject = z.infer<typeof entityTypeWithSubprojectSchema>;

export const entityLabelSchema = z.object({
  type: entityTypeWithSubprojectSchema,
  name: z.string(),
  id: uuidSchema,
});
export type EntityLabel = z.infer<typeof entityLabelSchema>;

export const portfolioTradeTypeSchema = z.enum(['Buy', 'Sell']);

export type OperationStatus = 'AwaitingUser' | 'Completed' | 'Error' | 'Processing';
